import { QueryClient } from '@tanstack/react-query';

import { shouldRetry } from './queryClient.utils';

/**
 * React Query client configuration
 *
 * Shared configuration for all queries and mutations in the application.
 * This instance is created once and provided at the app root level.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry once with 1 second delay, except for auth failures
      retry: shouldRetry,
      retryDelay: 1000,
      // Don't refetch when window regains focus (explicit user action preferred)
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: shouldRetry,
      retryDelay: 1000,
    },
  },
});
